/**
 * Pages that always render in light mode, whatever the visitor's theme: the landing is designed light (its dark
 * blocks set their own `dark` scope). Read by the root's first-paint theme script, the server render and the AppShell
 * theme effect; the visitor's saved preference is left untouched and applies again on every other page.
 */
export const LIGHT_ONLY_PATHS = ['/']

export function isLightOnlyPath(pathname: string) {
  return LIGHT_ONLY_PATHS.includes(pathname.replace(/\/+$/, '') || '/')
}
